import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import ElevatorWidget from '../components/ElevatorWidget';
import StatsBand      from '../components/StatsBand';
import ServiceCard    from '../components/ServiceCard';
import CtaBand        from '../components/CtaBand';
import { SERVICES, CERTIFICATIONS, HERO, PROJECTS } from '../constants/data';
import styles from './Home.module.css';

export default function Home() {
  const lineRef = useRef(null);

  /* Yükselen çizgi animasyonu */
  useEffect(() => {
    const el = lineRef.current;
    if (!el) return;
    let h = 0;
    const iv = setInterval(() => {
      h = Math.min(h + 1.5, 72);
      el.style.height = h + '%';
      if (h >= 72) clearInterval(iv);
    }, 10);
    return () => clearInterval(iv);
  }, []);

  return (
    <main>
      {/* ── HERO ──────────────────────────────────────────────────────── */}
      <section className={styles.hero}>
        {/* Arka plan dikey çizgiler */}
        <div className={styles.bgLines} aria-hidden="true">
          {[15, 35, 55, 75, 92].map(x => (
            <span key={x} style={{ left: `${x}%` }} />
          ))}
        </div>

        {/* Yükselen bakır çizgi */}
        <div ref={lineRef} className={styles.liftLine} aria-hidden="true" />

        {/* İçerik */}
        <div className={styles.heroContent}>
          <span className={styles.heroBadge}>{HERO.badge}</span>

          <h1 className={styles.heroHeading}>
            {HERO.title1} <span>{HERO.title2}</span> {HERO.title3}
          </h1>

          <p className={styles.heroDesc}>{HERO.desc}</p>

          <div className={styles.heroBtns}>
            <Link to="/iletisim" className="btn-primary">Ücretsiz Teklif Al</Link>
            <Link to="/hizmetler" className="btn-outline">Hizmetleri İncele →</Link>
          </div>

          <StatsBand />
        </div>

        {/* Asansör animasyonu */}
        <ElevatorWidget />
      </section>

      {/* ── SERVICES PREVIEW ──────────────────────────────────────────── */}
      <section className={styles.servicesSection}>
        <div className={styles.container}>
          <div className="section-title">
            <span className="eyebrow">Ne Yapıyoruz</span>
            <h2>Hizmetlerimiz</h2>
            <p>
              Asansör sektöründe uçtan uca çözümler sunuyor,
              montajdan bakıma her adımda yanınızda oluyoruz.
            </p>
          </div>

          <div className={styles.servicesGrid}>
            {SERVICES.map(s => (
              <ServiceCard key={s.id} icon={s.icon} title={s.title} desc={s.short} linkTo="/hizmetler" />
            ))}
          </div>

          <div className={styles.servicesMore}>
            <Link to="/hizmetler" className="btn-outline">
              Tüm Hizmetleri Görüntüle →
            </Link>
          </div>
        </div>
      </section>

      {/* ── WHY US ────────────────────────────────────────────────────── */}
      <section className={styles.whySection}>
        <div className={styles.container}>
          <div className={styles.whyGrid}>
            <div>
              <span className="eyebrow">Neden EMK?</span>
              <h2 className={styles.whyHeading}>
                Güvenlik önce,<br />kalite her zaman.
              </h2>
              <p className={styles.whyDesc}>
                18 yıllık sektör deneyimimiz, TSE ve CE sertifikalarımız,
                7/24 acil müdahale ekibimiz ve 850'yi aşkın başarılı proje
                referansımızla fark yaratıyoruz.
              </p>
            </div>
            <div className={styles.certGrid}>
              {CERTIFICATIONS.map((c, i) => (
                <div key={i} className={styles.certItem}>
                  <span className={styles.certIcon}>✓</span>
                  <span>{c}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ── PROJECTS PREVIEW ──────────────────────────────────────────── */}
      <section className={styles.projectsSection}>
        <div className={styles.container}>
          <div className="section-title">
            <span className="eyebrow">Tamamladığımız İşler</span>
            <h2>Projelerimiz</h2>
            <p>850'yi aşkın projeden bir seçki — montajdan modernizasyona kadar.</p>
          </div>

          <div className={styles.projectsGrid}>
            {PROJECTS.slice(0, 3).map((p, i) => (
              <Link key={i} to="/projeler" className={styles.projectCard}>
                <div className={styles.projectImageWrap}>
                  <img
                    src={`${process.env.PUBLIC_URL}/projects/${p.image}`}
                    alt={p.title}
                    className={styles.projectImage}
                    loading="lazy"
                  />
                  <span className={styles.projectBadge}>{p.categoryLabel}</span>
                </div>
                <div className={styles.projectBody}>
                  <h3 className={styles.projectTitle}>{p.title}</h3>
                  <p className={styles.projectLocation}>📍 {p.location}</p>
                </div>
              </Link>
            ))}
          </div>

          <div className={styles.servicesMore}>
            <Link to="/projeler" className="btn-outline">
              Tüm Projeleri Görüntüle →
            </Link>
          </div>
        </div>
      </section>

      {/* ── CTA ───────────────────────────────────────────────────────── */}
      <CtaBand />
    </main>
  );
}
